import React from "react";
import { useState } from "react";
import logo from "../../../assets/logo.svg";
import { TiAdjustContrast } from "react-icons/ti";
import { useLocation, useNavigate } from "react-router-dom";

export default function FixedHeader() {
  const [isDarkMode, setIsDarkMode] = useState(true);

  const setTheme = () => {
    document.body.classList.toggle("dark");
    setIsDarkMode(!isDarkMode);
  };

  const { pathname } = useLocation();
  const navigate = useNavigate();

  return (
    <div className="absolute px-[2%] mt-8 lg:!px-[4%] lg:mt-12 w-full z-10">
      <div className="flex justify-between items-center w-full">
        {pathname.includes("details") ? (
          <button onClick={() => navigate(-1)}>
            <img
              src={logo}
              alt="logo"
              className="w-[35px] h-[35px] sm:w-[60px] sm:h-[60px]"
            />
          </button>
        ) : (
          <a href="#home">
            <img
              src={logo}
              alt="logo"
              className="w-[35px] h-[35px] sm:w-[60px] sm:h-[60px]"
            />
          </a>
        )}
        <button onClick={() => setTheme()}>
          <div className="rounded-full flex justify-center items-center w-[35px] h-[35px] sm:w-[60px] sm:h-[60px] backdrop-blur-[1px] bg-secondary/50">
            <TiAdjustContrast className="!text-base sm:!text-2xl" />
          </div>
        </button>
      </div>
    </div>
  );
}
